import dynamic from "next/dynamic";

// import LoginScreen from "./loginscreen";
const LoginScreen = dynamic(() => import("./loginscreen"), {
  ssr: false,
});
export default function Home() {

  return (
    <>
    <LoginScreen/>
    </>
  );
}
